import { render, staticRenderFns } from "./RightTickCircle.vue?vue&type=template&id=372f90fa&"
import script from "./RightTickCircle.vue?vue&type=script&lang=ts&"
export * from "./RightTickCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports